require('angular')
	.module('RealEstateMap', [require('../filter')])
	.controller('MapController', require('./controller'))
	.factory('MapProvider', require('./provider'));

module.exports = 'RealEstateMap';